

















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { RecomendationModule } from '@/app/store/modules/recomendation'
@Component
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined

  private fileName: string = ''
  private idCategory: string = ''
  private id: number = 0

  public funcModalDelete(item, index, button) {
    //  console.log(item)
    this.fileName = item.title
    this.idCategory = item.type
    this.id = item.id
    this.$root.$emit('bv::show::modal', 'modalCheckbox', button)
  }

  public funcDelete() {
    const contentType = this.idCategory
    const contentId = this.id
    RecomendationModule.deleteRecomendation({ contentType, contentId })
    this.$root.$emit('bv::hide::modal', 'modalCheckbox')
  }
}
